import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import ICONS from "../../../assets/Icons";

const FieldForceAccountError = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const createAccountHandler = () => {
    navigate("/field_force_account_dashboard/create_field_force_account");
  };

  const dashboardHandler = () => {
    navigate("/field_force_account_dashboard");
  };

  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS.ADD_BUTTON,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
      },
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--negative-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      title="Failed to create a field force account."
      buttonRows={buttonRows}
      hoverOption="white"
    >
      <TabsWeapperSection title="Error details">
        <>
          {Array.isArray(state) ? (
            <>
              {state.map((err, index) => (
                <InfoCard
                  key={index}
                  bgColor="var(--negative-card)"
                  rows={[
                    {
                      leftTitle:
                        Object.values(err)?.[0]?.base[0] ||
                        "An unknown error occurred",
                      leftSubTitle: "Error description",
                    },
                  ]}
                />
              ))}
            </>
          ) : (
            <InfoCard
              bgColor="var(--negative-card)"
              rows={[
                {
                  leftTitle:
                    Object.values(state)?.[0] || "An unknown error occurred",
                  leftSubTitle: "Error description",
                },
              ]}
            />
          )}
        </>
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default FieldForceAccountError;
